module.exports = __webpack_public_path__ + "img/pic3.acd1b5c2.jpg";